/**
 * Haptic feedback utilities for mobile devices
 * Provides vibration feedback for interactive elements
 */

/**
 * Trigger haptic feedback on supported devices
 * @param pattern - Vibration pattern (default: light tap)
 */
export function triggerButtonHaptic(pattern: number | number[] = 10): void {
  if (typeof window === 'undefined') return;
  
  // Check if Vibration API is available
  if ('vibrate' in navigator) {
    try {
      navigator.vibrate(pattern);
    } catch (e) {
      // Silently fail if vibration is not available or blocked
      console.debug('Vibration API not available');
    }
  }
}

/**
 * Trigger a light tap haptic feedback
 */
export function triggerLightTap(): void {
  triggerButtonHaptic(10);
}

/**
 * Trigger a medium haptic feedback
 */
export function triggerMediumTap(): void {
  triggerButtonHaptic(20);
}

/**
 * Trigger a strong haptic feedback
 */
export function triggerStrongTap(): void {
  triggerButtonHaptic([10, 50, 20]);
}

